import { Button } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { T, TPlainTextKey } from '../../../Translations';

interface Step {
  heading: TPlainTextKey;
  body: TPlainTextKey;
}

const steps: ReadonlyArray<Step> = [
  {
    heading: 'Add an identity provider',
    body: 'Pick your vendor - Microsoft Entra ID, Okta, or another SAML 2.0 provider. We create a dedicated connection right away. You can add more than one.',
  },
  {
    heading: 'Configure your IdP with the details we generate',
    body: 'We give you the identifiers, reply URL, and attribute claims your IdP administrator needs.',
  },
  {
    heading: 'Come back with your metadata URL',
    body: 'Once your IdP app is set up, paste the federation metadata URL it generated. We finish the connection automatically.',
  },
  {
    heading: 'Test, then assign domains',
    body: "Run a test sign-in to finish setup. Then, right from this page, point each login domain at the connection it should use - domains you don't assign keep password sign-in.",
  },
];

const GetStarted: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h3 className="text-base font-semibold text-foreground">
        <T kind="Get started" />
      </h3>
      <div className="mt-3 rounded-lg border border-border bg-card p-6">
        <ol className="m-0 flex list-none flex-col gap-5 p-0">
          {steps.map((step, index) => (
            <li key={step.heading} className="flex gap-4">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-bold text-primary-foreground">
                {index + 1}
              </span>
              <span>
                <span className="block font-semibold text-foreground">
                  <T kind={step.heading} />
                </span>
                <span className="block text-sm text-muted-foreground">
                  <T kind={step.body} />
                </span>
              </span>
            </li>
          ))}
        </ol>
        <div className="mt-6">
          <Button
            color="primary"
            onClick={() => navigate('/single_sign_on/add')}
            data-intercom-target="sso-add-identity-provider-button"
          >
            <T kind="Add identity provider" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default observer(GetStarted);
